module.exports = __webpack_public_path__ + "img/lock-blue-grey-lighten-2.de507722.svg";